<template>
  <div class="e-popup-content">
    <div class="e-date-time">
      <div class="e-date-time-icon e-icons" /><div class="e-date-time-wrapper e-text-ellipsis">
        <div class="e-date-time-details e-text-ellipsis">
          {{ data.startDate | formatShortDate }}
        </div>
      </div>
    </div>
    <div v-if="data.description" class="e-resource">
      <div class="e-description-icon e-icons" />
      <div class="e-location-details e-text-ellipsis overflow-y-scroll" style="max-height: 400px">
        {{ data.description }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: {},
      };
    },
  };
</script>

<style scoped>
.e-notes-icon:before{
    content:'\ec26';
    color: rgba(0, 0, 0, 0.54);
    font-size: 18px;
    padding-right: 13px;
}
</style>